import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { a as InternalInput } from '../Input/Input-Box9VsPu.js';
import { P as Prefix } from '../Input/Prefix-DUDk3Gbu.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { h as close, B as search } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { I as IconButton } from '../Button/IconButton/IconButton-Copc-LdF.js';
import { I as Icon } from '../Icon/Icon-AcXbY_t4.js';

const StyledIconButton = /*#__PURE__*/styled(IconButton).withConfig({
  componentId: "sc-storm-ui-40027066__sc-mrslaf-0"
})(["visibility:", ";&&,&&:visited,&&:active,&&:link,&&:hover{color:", ";}&&:hover{background-color:transparent;}&&{min-height:", ";", "}"], ({
  $isVisible
}) => $isVisible ? 'visible' : 'hidden', ({
  theme
}) => theme.text.color.tertiary, ({
  theme
}) => `calc(${theme.controls.height.base.default} - (2*${theme.border.width.default}))`, isMobile(css(["min-height:", ";"], ({
  theme
}) => `calc(${theme.controls.height.base.mobile} - (2*${theme.border.width.default}))`)));
const StyledSearchIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40027066__sc-mrslaf-1"
})(["color:", ";"], ({
  theme
}) => theme.text.color.secondary);
const SearchInput = ({
  taktId,
  taktValue,
  clearBtnProps = {},
  clearButtonLabel = 'Clear search terms',
  onClear,
  disabled = false,
  label = 'Search',
  hideLabel = true,
  value,
  prefix,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('search-input')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(InternalInput, _extends({}, getDataTaktAttributes(), rest, {
  disabled: disabled,
  label: label,
  value: value,
  hideLabel: hideLabel,
  prefix: /*#__PURE__*/React__default.createElement(Prefix, {
    $ignoreTextDirection: rest.ignoreTextDirection,
    $disabled: disabled
  }, prefix !== null && prefix !== void 0 ? prefix : /*#__PURE__*/React__default.createElement(StyledSearchIcon, {
    type: search,
    "aria-hidden": "true"
  })),
  suffix: /*#__PURE__*/React__default.createElement(StyledIconButton, _extends({}, clearBtnProps, {
    $isVisible: !!value,
    type: "button",
    onClick: onClear,
    "aria-label": clearButtonLabel,
    "aria-hidden": !value,
    disabled: disabled
  }, getDataTaktAttributes({
    taktIdSuffix: 'close-button'
  }), {
    icon: close,
    label: clearButtonLabel,
    variant: "transparent"
  })),
  type: "search"
})));

export { SearchInput as S };
//# sourceMappingURL=SearchInput-l0Hk4wc3.js.map
